import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Objects} from "components";

const breadcrumbsStatic = [
	{
		name: 'Dashboard',
		url: '/',
		icon: 'dashboard',
	},
	{
		name: 'Dispositions',
		url: '/dispositions',
		icon: 'upload',
	},
	{
		name: 'NICS Status',
		url: '/dispositions/enics_statuses',
		icon: 'check-square-o',
	},
];

export default class Enics_Statuses extends Framework.Components.View {

	render() {
		return (
			<div className="container-fluid">
				<Framework.Components.PageBar breadcrumbs={breadcrumbsStatic} history={this.props.history}/>

				<Objects.DispositionEnicsStatuses
					id={this.props.match.params.id}
					history={this.props.history}
					locations={this.props.locations}
					states={this.props.states}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
					updateName={this.updateName}
					baseUrl={this.props.baseUrl}
				/>
			</div>
		);
	}
}
